module.exports = __webpack_public_path__ + "static/media/nicholas-green-nPz8akkUmDI-unsplash.8f3e4416.jpg";